export const MESSAGE_INVALID_FIRST_NAME_LENGTH =
  "First name is a required field.";
export const MESSAGE_INVALID_LAST_NAME_LENGTH =
  "Last name is a required field.";
export const MESSAGE_INVALID_NAME_LENGTH = "This is a required field.";
export const MESSAGE_INVALID_PASSWORD =
  "Password length should be greater than or equal to 8 characters.";
export const MESSAGE_INVALID_PASSWORD_PATTERN =
  "Password must contain at least (One lowercase letter, One uppercase letter, One number and One special character)";
export const MESSAGE_INVALID_EMAIL_PATTERN = "Enter a valid Email address.";
export const MESSAGE_INVALID_EMAIL_LENGTH = "Email is a required field.";
export const MESSAGE_INVALID_PASSWORD_LENGTH = "Password is required.";
export const MESSAGE_INVALID_CONF_PASSWORD_LENGTH =
  "Confirm Password should be greater than or equal to 8 characters.";
export const MESSAGE_INVALID_DOMAIN = "Please enter a valid subdomain.";
export const MESSAGE_PASSWORD_CONFIRMPASSWORD_MISMATCH =
  "Password and confirm password should be same.";
export const CONFIRM_PASSWORD_PATTERN = "Confirm Password is required.";
export const DEFAULT_ERROR_MESSAGE = "Something went wrong.";
export const PASSWORD_PATTERN = "Password is required.";
export const MESSAGE_INVALID_CONFIRM_PASSWORD_PATTERN =
  "Confirm Password must contain at least (One lowercase letter, One uppercase letter, One number and One special character)";
